import React, { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { AdminShell } from "@/components/admin/AdminShell";
import { AdminDashboard } from "@/components/admin/AdminDashboard";
import { AdminProducts } from "@/components/admin/AdminProducts";
import { OrderTable } from "@/components/admin/OrderTable";
import { AdminCustomers } from "@/components/admin/AdminCustomers";
import { AdminCoupons } from "@/components/admin/AdminCoupons";
import { CmsManager } from "@/components/admin/CmsManager";
import { AdminSettings } from "@/components/admin/AdminSettings";
import { AdminHelp } from "@/components/admin/AdminHelp";
import { AdminCombos } from "@/components/admin/AdminCombos";
import { AdminEnquiries } from "@/components/admin/AdminEnquiries";
import { AdminAccount } from "@/components/admin/AdminAccount";

export default function Admin() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Redirect if not authorized in production
  useEffect(() => {
    if (!authLoading && process.env.NODE_ENV === "production") {
      if (!user || (!["yedageshantanu@gmail.com", "yedageshantanu70@gmail.com", "pawartanu417@gmail.com"].includes(user.email?.toLowerCase()) && user.role !== "admin")) {
        toast.error("Access denied. Admin privileges required.");
        navigate("/");
      }
    }
  }, [user, authLoading, navigate]);

  // Determine active component based on React Router path
  let content = <AdminDashboard />;
  if (pathname.startsWith("/admin/products")) {
    content = <AdminProducts />;
  } else if (pathname.startsWith("/admin/orders")) {
    content = <OrderTable />;
  } else if (pathname.startsWith("/admin/enquiries")) {
    content = <AdminEnquiries />;
  } else if (pathname.startsWith("/admin/customers")) {
    content = <AdminCustomers />;
  } else if (pathname.startsWith("/admin/coupons")) {
    content = <AdminCoupons />;
  } else if (pathname.startsWith("/admin/content")) {
    content = <CmsManager />;
  } else if (pathname.startsWith("/admin/settings")) {
    content = <AdminSettings />;
  } else if (pathname.startsWith("/admin/help")) {
    content = <AdminHelp />;
  } else if (pathname.startsWith("/admin/combos")) {
    content = <AdminCombos />;
  } else if (pathname.startsWith("/admin/account")) {
    content = <AdminAccount />;
  }

  return (
    <AdminShell>
      {content}
    </AdminShell>
  );
}
